import { FDealType } from '../../../../../JsonQuery';

export const getUrl = (url: string, dealType: FDealType) => {
  const [baseUrl, paramsStr] = url.split('?');
  const params = new URLSearchParams(paramsStr);

  const keysToKeep = [
    'center',
    'engine_version',
    'zoom',
    'deal_type',
    'offer_type',
    'type',
    'region',
    'location[0]',
    'house[0]',
  ];
  const filteredParams = new URLSearchParams();

  for (const key of keysToKeep) {
    if (params.has(key)) {
      filteredParams.set(key, params.get(key) as string);
    }
  }

  if (dealType === FDealType.Sale) {
    filteredParams.delete('type');
    filteredParams.set('deal_type', 'sale');
  } else if (dealType === FDealType.RentLongterm) {
    filteredParams.set('type', '4');
  }

  return `${baseUrl}?${filteredParams.toString()}`;
};
